import { render, staticRenderFns } from "./OSCECurrent.vue?vue&type=template&id=5de5cdb3&scoped=true"
import script from "./OSCECurrent.vue?vue&type=script&lang=js"
export * from "./OSCECurrent.vue?vue&type=script&lang=js"
import style0 from "./OSCECurrent.vue?vue&type=style&index=0&id=5de5cdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5cdb3",
  null
  
)

export default component.exports